export default __webpack_public_path__ + "static/media/coffee2.7a99464a.jpg";